import { Icon, IconProps } from "../";

export const MailIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M22 18.333C22 19.2534 21.2534 20 20.333 20H3.66699C2.74658 20 2 19.2534 2 18.333V9.47754C2.21458 9.71337 2.44545 9.92485 2.69336 10.0898L9.91992 14.9072C10.492 15.2885 11.2304 15.498 12 15.498C12.7696 15.498 13.508 15.2885 14.0801 14.9072L21.3066 10.0898C21.5546 9.92484 21.7854 9.71337 22 9.47754V18.333ZM20.333 4C21.2534 4 22 4.74658 22 5.66699V6.91699C21.9998 7.83341 21.3757 8.16653 20.6133 8.6748L13.3867 13.4922C13.0055 13.7468 12.5029 13.873 12 13.873C11.4971 13.873 10.9945 13.7468 10.6133 13.4922L3.38672 8.6748C2.62431 8.16653 2.00015 7.83341 2 6.91699V5.66699C2 4.74658 2.74658 4 3.66699 4H20.333Z" />
    </Icon>
  );
};
